import React from "react";
import {  PDFDocument } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import moment from 'moment';
import Loader from "react-loader-spinner";
import { useState, useEffect } from "react";
import {
  getCourtFormData,
  getFormsServedSpouse,
  putDocumentsServed,
  putServerAddress,
  putDocumentsMailedCityState,
  putDateDocumentsMailed,
  putDocumentsMailedAddress,
  putServerName,
  putMailCarrier,
  putMailedFromPostOffice,
  putResponsePacketByMail,
  startCourtServing,
  putServedPetitionPacket,
  successDocumentsServed
} from "./servingCourt.actions";
import {
  getStates,
  getFormData
} from "../forms/profileInformation/profileInformation.actions";
import { isEmpty, remove, filter, isUndefined, forEach } from "lodash";
import {
  FormGroup,
  Label,
  Input,
  CustomInput,
  Modal,
  ModalBody, 
} from "reactstrap";
import { serverApi ,parseDate } from "../../../global/globalFunctions";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

//COMPONENT

const ServingCourtFormRespondant = (props) => {

  const petitionerDetails = props.petitioner;
  const respondentDetails = props.respondent;
  const courtDetails = props.court;

  async function myFunctionFL_335() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-335`,{
      headers: { 
       Authorization: 'BEARER '+window.localStorage.getItem("auth_id") 
       },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const form = pdfDoc.getForm();

    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);
   
    !isUndefined(respondentDetails) && form.getField("attorney").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}` + `\n` + `${respondentDetails.streetAddress}` + `\n` + `${respondentDetails.city}` + `,` + `${resState[0].state_name}` + ` ` + `${respondentDetails.zip}`);
    !isUndefined(respondentDetails) && form.getField("telephone").setText(respondentDetails.telephone);
    !isUndefined(respondentDetails) && form.getField("email").setText(respondentDetails.email); 
    !isUndefined(courtDetails) && form.getField("streetAddress").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("city").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
    !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);
    form.getField("other").setText("");
    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);
    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);

    form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    form.getField("personServed").setText(props.documentsMailerName);
    form.getField("address").setText(props.documentsMailedAddress);
    form.getField("dateMailed").setText(parseDate(props.documentsMailedDate));
    form.getField("cityAndState").setText(props.documentsMailedFrom);
    form.getField("residence").setText(props.documentsMailerLive);
    
   if(props.isMailByPost === "1"){
    form.getCheckBox("depositing").check();
   }else{
    form.getCheckBox("depositing").uncheck();
   }
   if(props.isMailCarrier === "1"){
    form.getCheckBox("placing").check();
   }else{
    form.getCheckBox("placing").uncheck();
   } 

   
    

    let formsIds = filter(props.getFormsServed, form => {
      return FL_1.includes(form.documents_id.toString())
    });

    let formsNames = formsIds.map((item) => item.spouse_serverd_document);
       var formsNamesString = formsNames.join(",");
    form.getField("servedCopy").setText(formsNamesString + `,` + `${props.servedOtherFormsSpecify}`);
   


    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }
function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }
  //Component Level States
  const [activeStep, setActiveStep] = React.useState(0);
  const [servedByEmail, setservedByEmail] = useState(false);
  const [pickedUpByMailCarrier, setPickedUpByMailCarrier] = useState(false);
  const [isSubstitutedService, setSubstitutedService] = useState(false);
  const [isMailed, setMailed] = useState(false);
  const [isOther, setOther] = useState(false);
  const [isAttorneyEmployee, setAttorneyEmployee] = useState(false);
  const [isCourtEmployee, setCourtEmployee] = useState(false);
  const [isPrivateInvestigator, setPrivateInvestigator] = useState(false);
  const [isPhotoCopier, setPhotoCopier] = useState(false);

  const [isResponsePacketViaMail, setResponsePacketViaMail] = useState(false);
  const [FL_1, setFL_1] = useState([]);
  const [show, setShow] = useState(false);
  const [show_1, setShow_1] = useState(false);
  const [documentServedSpecify, setDocumentServedSpecify] = useState("");
  


     const handleContinue = () => {
       setActiveStep((prevActiveStep) => prevActiveStep - 1);
       setShow(false);
      }
     const handleClose = () => {
       setActiveStep((prevActiveStep) => prevActiveStep + 8);
       setShow(false);
     }
     const handleCloseMailCarrier = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 2);
      setShow_1(false);
    }


  useEffect(() => {
    props.getFormsServedSpouse();
    props.getCourtFormData({
        divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.startCourtServing({
      userId: window.localStorage.getItem("user_id"),
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.getStates(); 
    !isEmpty(window.localStorage.getItem("divorce_id")) && props.getFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    arrayCBOne();
  }, []);

  
  //STEPPER
  const classes = useStyles();
  
  function getSteps() {
    return [
      "Has your spouse been served the Response Packet (via mail)?",
      "What documents were served on your spouse? Check all that apply",
      "You are only required to serve by mail. Did you mail it from the post office? ",
      "Did you leave it to be picked up by the mail carrier?",
      "Who is your server? (Who mailed the forms to your spouse?) This cannot be you.",
      "Where does your server live? You can also provide your server’s business address.",
      "What address did your server mail these documents?",
      "When did your server mail these documents?",
      "What city and state did your server mail the documents from?",
    ];
  }
  const steps = getSteps();
  function getCheckedValue_1(value) {
    if (FL_1.includes(value)) {
      let dummyArray = FL_1;
      remove(dummyArray, function (val) {
        return val == value;
      });
    } else {
      let dummyArray = FL_1;
      dummyArray.push(value);
      setFL_1(dummyArray);
      
    }
  }

  const arrayCBOne =()=>{
    let cb = [];
    forEach([1, 2, 3, 4, 5, 6, 7], (y) => {
      let z = !isEmpty(props.selectedServedForms) && (props.selectedServedForms).includes(`${y}`)
      z == true && cb.push(z==true? `${y}` : "");
    });
    setFL_1(cb)
  }
  
  const handlePostFunc = () => {
      if (activeStep === 0) {
      props.putResponsePacketByMail({
        divorce_id: window.localStorage.getItem("divorce_id"),
        servedResponsePacket: document.getElementById("responsePacketViaMail").value === "1" ? document.getElementById("responsePacketViaMail").value : (setShow(true), document.getElementById("responsePacketViaMail").value),
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 1) {
      props.putDocumentsServed({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
        servedOtherFormSpcify :document.getElementById("servedDocumentsSpecify").value,
        documentServeSpouse: FL_1,
      });
    } else if (activeStep === 2) {
      props.putMailedFromPostOffice({
        divorce_id: window.localStorage.getItem("divorce_id"),
        mailPostOffice: document.getElementById("servedByEmail").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 3) {
      props.putMailCarrier({
        divorce_id: window.localStorage.getItem("divorce_id"),
        mailCarrier: (document.getElementById("pickedUpByMailCarrier").value === "0" || document.getElementById("pickedUpByMailCarrier").value === "-1") ? (setShow_1(true), document.getElementById("pickedUpByMailCarrier").value) : document.getElementById("pickedUpByMailCarrier").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 4) {
      props.putServerName({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverName: document.getElementById("whoIsYourServer").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 5) {
      props.putServerAddress({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverAddress: document.getElementById("yourServerAddress").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 6) {
      props.putDocumentsMailedAddress({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverMailDocumentAddress: document.getElementById(
          "mailedDocumentEmailAddress"
        ).value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 7) {
      props.putDateDocumentsMailed({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverMailDocumentDate: parseDate(document.getElementById("dateOfMail").value),
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 8) {
      props.putDocumentsMailedCityState({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverMailDocumentCity: document.getElementById("stateAndDate").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 9) {
    }
  };
  const handleNext = () => {
    handlePostFunc();
    setActiveStep((prevActiveStep) => (servedByEmail == "1"  && prevActiveStep === 2 ) ? prevActiveStep + 2 : prevActiveStep + 1);
    
   
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => (servedByEmail == "1"  && prevActiveStep === 4 ) ? prevActiveStep - 2 :
    (props.isPetitionPacketViaMail == "0" || props.isPetitionPacketViaMail == "-1"  && prevActiveStep === 9 ) ? prevActiveStep - 9 : 
    prevActiveStep - 1);
    
  };

  const handleReset = () => {
    setActiveStep(0);
  };
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <FormGroup>
              <Input
                defaultValue={props.isPetitionPacketViaMail}
                type="select"
                name="responsePacketViaMail"
                id="responsePacketViaMail"
                onChange={(e) =>
                  setResponsePacketViaMail(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 1:
        return (
          <div>
            <FormGroup>
              {/* <Label for="Forms">additional forms?</Label> */}
                        
                        {/* <CustomInput
                          id="1"
                          value="1"
                          type="checkbox"
                          label="Response, FL-120"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("1")}
                        /> */}
                        <CustomInput
                          id="UCCJEA, FL-105"
                          value="1"
                          type="checkbox"
                          label="UCCJEA, FL-105"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("1")}
                        />
                        <CustomInput
                          id="Declaration of Disclosure, FL-140"
                          value="2"
                          type="checkbox"
                          label="Declaration of Disclosure, FL-140"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("2")}
                        />
                        <CustomInput
                          id="3"
                          value="3"
                          type="checkbox"
                          label="Schedule of Assets and Debts, FL-142"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("3")}
                        />
                        <CustomInput
                          id="4"
                          value="4"
                          type="checkbox"
                          label="Income & Expense, FL-150"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("4")}
                        />
                         <CustomInput
                          id="5"
                          value="5"
                          type="checkbox"
                          label="Simplified I&E, FL-155"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("5")}
                        />
                         <CustomInput
                          id="6"
                          value="6"
                          type="checkbox"
                          label="Property Declaration, FL-160"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("6")}
                        />
                         <CustomInput
                          id="7"
                          value="7"
                          type="checkbox"
                          label="Request for Order, FL-300 (with blank FL-320)"
                          onChange={(e) => getCheckedValue_1(e.target.value)}
                          defaultChecked={props.selectedServedForms.includes("7")}
                        />
                        <br/>
                        <Label>Other [If other, please type below, this includes any local forms.]</Label>
                          <Input
                            id="servedDocumentsSpecify"
                            type="text"
                            defaultValue={props.servedOtherFormsSpecify}
                            onBlur={(e) => setDocumentServedSpecify(e.target.value)}
                          />
            </FormGroup>
          </div>
        );
      case 2:
        return (
          <div>
            {/* Q13 Started */}
            <FormGroup>
              <Input
                defaultValue={props.isMailByPost}
                type="select"
                name="servedByEmail"
                id="servedByEmail"
                onChange={(e) => setservedByEmail(JSON.parse(e.target.value))}
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 3:
        return (
          <div>
            {/* Q14 Started */}
            <FormGroup>
              <Input
                defaultValue={props.isMailCarrier}
                type="select"
                name="pickedUpByMailCarrier"
                id="pickedUpByMailCarrier"
                onChange={(e) =>
                  setPickedUpByMailCarrier(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 4:
        return (
          <div>
            <FormGroup>
              <Label for="whoIsYourServer">Name</Label>
              <Input
                defaultValue={props.documentsMailerName}
                type="text"
                id="whoIsYourServer"
                name="whoIsYourServer"
              />
            </FormGroup>
          </div>
        );
      case 5:
        return (
          <div>
            <FormGroup>
              <Label for="yourServerAddress">Server Address</Label>
              <Input
                placeholder="Full Address"
                defaultValue={props.documentsMailerLive}
                type="text"
                id="yourServerAddress"
                name="yourServerAddress"
              />
            </FormGroup>
          </div>
        );
      case 6:
        return (
          <div>
            <FormGroup>
              <Label for="mailedDocumentEmailAddress"> Address</Label>
              <Input
                placeholder="Full Address"
                defaultValue={props.documentsMailedAddress}
                type="text"
                id="mailedDocumentEmailAddress"
                name="mailedDocumentEmailAddress"
              />
            </FormGroup>
          </div>
        );
      case 7:
        return (
          <div>
            <FormGroup>
              <Label for="dateOfMail">Mail Date</Label>
              <Input
                defaultValue={moment(props.documentsMailedDate == "1947-01-01" ? "" : props.documentsMailedDate).format('YYYY-MM-DD')}
                type="date"
                id="dateOfMail"
                name="dateOfMail"
              />
            </FormGroup>
          </div>
        );
      case 8:
        return (
          <div>
            <FormGroup>
              <Label for="stateAndDate">City and State</Label>
              <Input
                defaultValue={props.documentsMailedFrom}
                type="text"
                id="stateAndDate"
                name="stateAndDate"
              />
            </FormGroup>
          </div>
        );

      default:
        return "DEFAULT CASES...";
    }
  }

  return (
    <div className={classes.root}>
      {props.isFetchingCourtFormData ?
      <div  style={{marginLeft:"42%", marginTop:"18%"}}>
        <Loader
        type="Puff"
        color="#00BFFF"
        height={120}
        width={120}
      />
      </div>
      :
      <div>
      <Stepper activeStep={activeStep} orientation="vertical" style={{
                        fontStyle: "normal",
                        fontFamily: "sans-serif",
                        backgroundColor: "white",
                        textAlign: "justify",
                        textJustify: "inter-word",
                        padding: "20px 70px"
                    }}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography>{getStepContent(index)}</Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                  >
                    {activeStep === steps.length - 1 ? "Finish" : "Next"}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <div>
          <Button style={{backgroundColor:"red",color:"white"}} onClick={handleReset} className={classes.button}>
            Reset
          </Button>
          <Button style={{backgroundColor:"#3f51b5",color:"white"}} onClick={handleBack} className={classes.button}>
           Back
          </Button>
        </div>
        </Paper>
      )}
      <div style={{display:"flex",float:"right"}}>
       <Button
        style={{ marginLeft:"2px" }}
        variant="contained"
        color="primary"
        onClick={myFunctionFL_335}
      >
        Print FL-335
      </Button>
      

      <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>
        <ModalBody> 
          <p>Please return to this interview when your spouse has been served or go back and select “YES” to continue.</p>
           <br />
           <br />
           Do you want to continue ?
        </ModalBody>
        <div style={{display:"flex",color: "white",marginBottom:"3px"}}>
        <Button
             style={{ width: "50%", color: "blue", backgroundColor: "white",marginLeft:"2px",border:"0.5px solid blue" }}
          onClick={handleContinue}
        >
          Yes
        </Button>
        <Button
          style={{ width: "50%",  color: "blue", backgroundColor: "white",border:"0.5px solid blue",marginLeft:"2px",marginRight:"2px" }}
          onClick={handleClose}
        >
          No
        </Button>
        </div>
      </Modal>
      
      {/* Mail Carrier MODAL */}
      
      <Modal isOpen={show_1} style={{ marginTop: "300px", marginLeft: "46%" }}>
        <ModalBody> 
          <p> You must select either the post office or mail carrier. Please go back and select one.</p>
        </ModalBody>
        <Button
          style={{ color: "blue", backgroundColor: "white",border:"0.5px solid blue",marginLeft:"2px",marginRight:"2px" }}
          onClick={handleCloseMailCarrier}
        >
         Ok
        </Button>
      
      </Modal>

      </div>
      </div>}
    </div>
  );
};

const mapStateToProps = (state) => ({

  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,
  isMailCarrier : state.servingCourtReducer.isMailCarrier,
  getFormsServed: state.servingCourtReducer.getFormsServedSpouse,
  isPetitionPacketViaMail: state.servingCourtReducer.isPetitionPacketViaMail,
  isMailByPost: state.servingCourtReducer.isMailByPost,
  servedOtherFormsSpecify: state.servingCourtReducer.servedOtherFormsSpecify,
  documentsMailerName: state.servingCourtReducer.documentsMailerName,
  documentsMailerLive: state.servingCourtReducer.documentsMailerLive,
  documentsMailedAddress: state.servingCourtReducer.documentsMailedAddress,
  documentsMailedDate: state.servingCourtReducer.documentsMailedDate,
  documentsMailedFrom: state.servingCourtReducer.documentsMailedFrom,
  filedPetition: state.petitionerPacketReducer.filedPetition,
  isFetchingCourtFormData: state.servingCourtReducer.isFetchingCourtFormData,
  selectedServedForms: state.servingCourtReducer.selectedServedForms,
  states: state.ProfileInformationReducer.states,
  isFetchingStates: state.ProfileInformationReducer.isFetchingStates,
});

const mapDispatchToProps = (dispatch) => {
  return {
    putServerAddress: (data) => dispatch(putServerAddress(data)),
    getCourtFormData: (data) => dispatch(getCourtFormData(data)),
    getFormsServedSpouse: () => dispatch(getFormsServedSpouse()),
    putDocumentsServed: (data) => dispatch(putDocumentsServed(data)),
    putDocumentsMailedCityState: (data) =>dispatch(putDocumentsMailedCityState(data)),
    putDateDocumentsMailed: (data) => dispatch(putDateDocumentsMailed(data)),
    putDocumentsMailedAddress: (data) =>dispatch(putDocumentsMailedAddress(data)),
    putServerName: (data) => dispatch(putServerName(data)),
    putMailCarrier: (data) => dispatch(putMailCarrier(data)),
    putMailedFromPostOffice: (data) => dispatch(putMailedFromPostOffice(data)),
    putResponsePacketByMail: (data) => dispatch(putResponsePacketByMail(data)),  
    putServedPetitionPacket: (data) => dispatch(putServedPetitionPacket(data)),
    startCourtServing: (data) => dispatch(startCourtServing(data)),
    successDocumentsServed: (data) => dispatch(successDocumentsServed(data)),

    getFormData: (data) => dispatch(getFormData(data)),  
    getStates: () => dispatch(getStates()),
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ServingCourtFormRespondant);
